import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { searchNewsArticles, setSearchParameters } from 'actions/admin/newsArticles';
import { performSearch, mergeSearchParameters } from 'components/adminTable/AdminTableHelper';

import AdminContentWrapper from '../../presentational/AdminContentWrapper';
import AdminPage from '../../presentational/AdminPage';
import routes from 'routes';
import AdminTable from 'components/adminTable/AdminTable';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Loader from 'common/Loader';
import ShortDate from 'common/ShortDate';
import { Link } from 'react-router-dom';

const NewsArticles = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const searchResult = useSelector(state => state.admin.newsArticles.searchResult);
    const searchParametersFromState = useSelector(state => state.admin.newsArticles.searchParameters);

    const defaultParameters = {
        page: 0,
        pageSize: 20,
        sortByColumn: 'publicationDate',
        sortDirection: 'desc'
    };

    const columns = [
        {
            title: 'Id',
            id: 'id',
            render: newsArticle => <Link to={routes.admin.updateNewsArticle.replace(':newsArticleId', newsArticle.id)}>{newsArticle.id}</Link>,
            align: 'right'
        },
        {
            title: 'Title',
            id: 'title',
            render: newsArticle => newsArticle.title
        },
        {
            title: 'PublicationDate',
            id: 'publicationDate',
            render: newsArticle => <ShortDate value={newsArticle.publicationDate}/>
        }
    ];

    const search = parameters => {
        const searchParameters = mergeSearchParameters(parameters, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    };

    useEffect(() => {
        const searchParameters = mergeSearchParameters({}, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    }, []);

    const handleSort = sortingParameters => {
        search(sortingParameters);
    };

    const handlePageChange = newPage => {
        search({ page: newPage });
    };

    const handlePageChangeSize = newPageSize => {
        search({ page: 0, pageSize: newPageSize });
    };

    const performSearchObject = {
        searchParametersFromState,
        setSearchParametersToState: parameters => dispatch(setSearchParameters(parameters)),
        searchResult,
        search,
        apiCall: parameters => dispatch(searchNewsArticles(parameters)),
        location,
        history,
        isInitializedRef: useRef()
    };

    const actionPanel = (
        <Box>
            <Button
                type="button"
                variant="contained"
                color="primary"
                component={Link}
                to={routes.admin.createNewsArticle}
            >
                Create new article
            </Button>
        </Box>
    );

    return (
        <AdminPage title="News articles" actionPanel={actionPanel}>
            <AdminContentWrapper type="listing">
                <Box>
                    {
                        searchResult.isLoading && <Loader />
                    }
                    {
                        searchResult.items && (
                            <AdminTable
                                isPaged
                                items={searchResult.items}
                                count={searchResult.count}
                                page={searchResult.page}
                                pageSize={searchResult.pageSize}
                                columns={columns}
                                sortByColumn={columns.find(c => c.id === searchParametersFromState.sortByColumn)}
                                sortDirection={searchParametersFromState.sortDirection}
                                onSort={handleSort}
                                onPageChange={handlePageChange}
                                onPageChangeSize={handlePageChangeSize}
                            />
                        )
                    }
                </Box>
            </AdminContentWrapper>
        </AdminPage>
    );
};

export default NewsArticles;
